import React from "react";

interface StatePanelProps {
  title: string;
  message: string;
  variant?: "info" | "warning" | "error";
}

const VARIANT_ICONS: Record<string, string> = {
  info: "ℹ",
  warning: "⚠",
  error: "✕",
};

export function StatePanel({ title, message, variant = "info" }: StatePanelProps): JSX.Element {
  const icon = VARIANT_ICONS[variant] ?? VARIANT_ICONS.info;

  return (
    <section
      className={`state-panel state-${variant}`}
      role={variant === "error" ? "alert" : "status"}
    >
      <div className="state-panel-icon" aria-hidden="true">{icon}</div>
      <div className="state-panel-content">
        <h3 className="state-panel-title">{title}</h3>
        <p className="state-panel-message">{message}</p>
      </div>
    </section>
  );
}
